/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {ConversionCancelRequest} from "../model/conversion-cancel-request";
import {ConversionDismissRequest} from "../model/conversion-dismiss-request";
import {ConversionPauseRequest} from "../model/conversion-pause-request";
import {ConversionResumeRequest} from "../model/conversion-resume-request";
import {CreateInternalStreamingForRecordingRequest} from "../model/create-internal-streaming-for-recording-request";
import {DeleteConversionRequest} from "../model/delete-conversion-request";
import {DeleteFileSetRequest} from "../model/delete-file-set-request";
import {FileSet} from "../model/file-set";
import {GetCurrentConversionsInternalResponse} from "../model/get-current-conversions-internal-response";
import {SetStreamingFileSetRequest} from "../model/set-streaming-file-set-request";
import {StreamingSetStateInfo} from "../model/streaming-set-state-info";

@Injectable({
    providedIn: "root",
})
export class SimInternalStreamingService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public cancel(request: ConversionCancelRequest) {
        return super.post<void>(`/api/InternalStreaming/Cancel`, request);
    }

    public checkIfRecordingHasFileSet(scenarioRecordingId: string) {
        return super.get<boolean>(`/api/InternalStreaming/CheckIfRecordingHasFileSet`, {scenarioRecordingId: scenarioRecordingId});
    }

    public createInternalStreamingForRecording(request: CreateInternalStreamingForRecordingRequest) {
        return super.post<boolean>(`/api/InternalStreaming/CreateInternalStreamingForRecording`, request);
    }

    public deleteConversion(request: DeleteConversionRequest) {
        return super.post<boolean>(`/api/InternalStreaming/DeleteConversion`, request);
    }

    public deleteFileSet(request: DeleteFileSetRequest) {
        return super.post<boolean>(`/api/InternalStreaming/DeleteFileSet`, request);
    }

    public dismiss(request: ConversionDismissRequest) {
        return super.post<void>(`/api/InternalStreaming/Dismiss`, request);
    }

    public getCurrentConversions(scenarioRecordingId: string = null, last: number = 2147483647, excludeIdle: boolean = false) {
        return super.get<GetCurrentConversionsInternalResponse>(`/api/InternalStreaming/GetCurrentConversions`, {scenarioRecordingId: scenarioRecordingId, last: last, excludeIdle: excludeIdle});
    }

    public getFileSets() {
        return super.get<FileSet[]>(`/api/InternalStreaming/GetFileSets`, );
    }

    public getFileSetsForTrainingRoom(trainingRoomId: string) {
        return super.get<FileSet[]>(`/api/InternalStreaming/GetFileSetsForTrainingRoom`, {trainingRoomId: trainingRoomId});
    }

    public getStreamingSetState(fileSetId: string) {
        return super.get<StreamingSetStateInfo>(`/api/InternalStreaming/GetStreamingSetState`, {fileSetId: fileSetId});
    }

    public getStreamingSetStates(fileSetIds: string[]) {
        return super.get<StreamingSetStateInfo[]>(`/api/InternalStreaming/GetStreamingSetStates`, {fileSetIds: fileSetIds});
    }

    public pause(request: ConversionPauseRequest) {
        return super.post<void>(`/api/InternalStreaming/Pause`, request);
    }

    public resume(request: ConversionResumeRequest) {
        return super.post<void>(`/api/InternalStreaming/Resume`, request);
    }

    public setFileSetStreamingState(request: SetStreamingFileSetRequest) {
        return super.post<boolean>(`/api/InternalStreaming/SetFileSetStreamingState`, request);
    }

    public upsertFileSet(fileSet: FileSet) {
        return super.post<boolean>(`/api/InternalStreaming/UpsertFileSet`, fileSet);
    }
}